import ColorfulCaptcha from './colorful-captcha';
export default ColorfulCaptcha;
